import api, { request } from '../../../../api';
import { IStore } from '../../../index';

export const getGroups = async (state: IStore, clubId: string | number, force?: boolean) => {
  if (
    state.adminGroups &&
    state.adminGroups.groups &&
    state.adminGroups.groups.length > 0 &&
    !force
  ) {
    return state;
  }

  const response = await request.get(`${api.admin.clubs}${clubId}/groups/`);

  if (response.error) {
    return { errors: { groups: { msg: 'Error retrieving club groups.' } } };
  }

  return {
    adminGroups: {
      groups: response
    }
  };
};
